import React from 'react';
import { Icon } from 'semantic-ui-react';
import { Device } from '../logic/Device';
import { apiEmblazon, apiGetChargePermutations, ChargePermutations } from '../logic/HeraldryAPI';

import 'semantic-ui-css/semantic.min.css';
import './Device.css';

interface Props {
    device: Device | undefined,
    setOptions: (options: ChargePermutations) => void,
}
interface State {
    error?: boolean;
    rendering?: boolean;
    shieldData?: string;
}

export class DeviceUI extends React.Component<Props, State> {
    static imageBlob: Blob;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    public render() {
        // console.log("Device: design=" + JSON.stringify(this.props.design));

        var image: JSX.Element | undefined;
        if (this.state.error) {
            image = <div id="heraldry-device-rendering">
                <Icon name="warning circle" flipped="horizontally" size="huge" />
                <span>Please try again</span>
            </div>;
        } else if (this.state.rendering) {
            image = <div id="heraldry-device-rendering">
                <Icon name="shield alternate" flipped="horizontally" size="huge" loading={true} />
            </div>;
        } else if (this.state.shieldData) {
            image = <img id="device-img" src={this.state.shieldData} alt="" />;
        }

        return <div style={{ position: "relative" }}>
            <div id="device-outer">
                <a href={this.state.shieldData} download="Worldspinner Heraldry" >
                    <div id="device-download" className='wsCenter' >
                        <img id="device-download-img" src={require("./download.png")} alt="download" />
                    </div>
                </a>
                <div id="device-inner">
                    {image}
                </div>
            </div>
        </div>;
    }

    public async componentDidMount() {
        this.update();
    }

    public async componentDidUpdate(prevProps: Props) {
        const currentDesign = JSON.stringify(this.props.device);
        const prevDesign = JSON.stringify(prevProps.device);
        if (currentDesign !== prevDesign) {
            this.update();
        }
    }

    private async update() {
        try {
            if (this.props.device) {
                this.setState({ rendering: true, shieldData: undefined, error: false })
                const chargePerms = await apiGetChargePermutations(this.props.device);
                this.props.setOptions(chargePerms);
                const shieldData = await apiEmblazon(this.props.device);
                this.setState({ rendering: false, shieldData, error: false });
            }
        } catch (e) {
            console.error("Device: failure during emblazoning: ", e);
            this.setState({ rendering: false, shieldData: undefined, error: true });
        }
    }

}
